.aLink {
  &:hover {
    xxxbackground: rgba(255, 255, 255, 0.25) !important;
  }
}
.active {
  xxxbackground: rgba(255, 255, 255, 0.15) !important;
}
